export const REGIONS = [
  { name: "Africa", count: 30, color: "#3fb950" },
  { name: "Asia", count: 13, color: "#58a6ff" },
  { name: "MENA", count: 7, color: "#d29922" },
  { name: "Europe & N. America", count: 11, color: "#bc8cff" },
  { name: "Latin America & Caribbean", count: 12, color: "#ff7b72" },
];

/* ─── COUNTRY → REGION (interactive coverage map, full named coverage) ─── */
export const COUNTRY_REGION = {
  // Africa
  "Dem. Rep. Congo": "Africa", "Democratic Republic of the Congo": "Africa",
  "Nigeria": "Africa", "Cameroon": "Africa", "Niger": "Africa", "Ghana": "Africa",
  "Kenya": "Africa", "Zambia": "Africa", "Malawi": "Africa", "Zimbabwe": "Africa",
  "Tanzania": "Africa", "United Republic of Tanzania": "Africa", "Lesotho": "Africa",
  "Sierra Leone": "Africa", "Rwanda": "Africa", "Ethiopia": "Africa", "Liberia": "Africa",
  "Togo": "Africa", "South Africa": "Africa", "Madagascar": "Africa", "Mali": "Africa",
  "Burkina Faso": "Africa", "Chad": "Africa", "Central African Rep.": "Africa",
  "Central African Republic": "Africa", "Guinea-Bissau": "Africa", "Burundi": "Africa",
  "Côte d'Ivoire": "Africa", "Ivory Coast": "Africa", "Morocco": "Africa", "Guinea": "Africa",
  "Seychelles": "Africa", "Benin": "Africa", "Botswana": "Africa",
  // Asia
  "Myanmar": "Asia", "Burma": "Asia", "Thailand": "Asia", "Sri Lanka": "Asia",
  "Indonesia": "Asia", "China": "Asia", "Vietnam": "Asia", "Bangladesh": "Asia",
  "Cambodia": "Asia", "Philippines": "Asia", "Tajikistan": "Asia", "India": "Asia",
  "Bhutan": "Asia", "Uzbekistan": "Asia",
  // Latin America & Caribbean
  "Ecuador": "Latin America & Caribbean", "Guatemala": "Latin America & Caribbean",
  "Nepal": "Latin America & Caribbean", "Peru": "Latin America & Caribbean",
  "Brazil": "Latin America & Caribbean", "Haiti": "Latin America & Caribbean",
  "Bolivia": "Latin America & Caribbean", "Chile": "Latin America & Caribbean",
  "Colombia": "Latin America & Caribbean", "Honduras": "Latin America & Caribbean",
  "Paraguay": "Latin America & Caribbean", "Mexico": "Latin America & Caribbean",
  // MENA
  "Iran": "MENA", "Jordan": "MENA", "Tunisia": "MENA", "Lebanon": "MENA",
  "Palestine": "MENA", "West Bank": "MENA", "Iraq": "MENA", "Syria": "MENA",
  // Europe & North America
  "United Kingdom": "Europe & N. America", "United States of America": "Europe & N. America",
  "United States": "Europe & N. America", "Serbia": "Europe & N. America",
  "Republic of Serbia": "Europe & N. America", "Denmark": "Europe & N. America",
  "Armenia": "Europe & N. America", "Ukraine": "Europe & N. America",
  "Kosovo": "Europe & N. America", "Georgia": "Europe & N. America",
  "Moldova": "Europe & N. America", "Albania": "Europe & N. America", "Spain": "Europe & N. America",
};

/* ─── COVERAGE SPOTLIGHT (human-readable named lists per region) ─── */
export const COVERAGE_SPOTLIGHT = [
  { region: "Africa", color: "#3fb950", countries: ["DR Congo","Nigeria","Cameroon","Niger","Ghana","Kenya","Zambia","Malawi","Zimbabwe","Tanzania","Lesotho","Sierra Leone","Rwanda","Ethiopia","Liberia","Togo","South Africa","Madagascar","Mali","Burkina Faso","Chad","CAR","Guinea-Bissau","Burundi","Côte d'Ivoire","Morocco","Guinea","Seychelles","Benin","Botswana"] },
  { region: "Asia", color: "#58a6ff", countries: ["Myanmar","Thailand","Sri Lanka","Indonesia","China","Vietnam","Bangladesh","Cambodia","Philippines","Tajikistan","India","Bhutan","Uzbekistan"] },
  { region: "Latin America & Caribbean", color: "#ff7b72", countries: ["Ecuador","Guatemala","Nepal","Peru","Brazil","Haiti","Bolivia","Chile","Colombia","Honduras","Paraguay","Mexico"] },
  { region: "MENA", color: "#d29922", countries: ["Iran","Jordan","Tunisia","Lebanon","Gaza/West Bank","Iraq","Syria"] },
  { region: "Europe & N. America", color: "#bc8cff", countries: ["United Kingdom","United States","Serbia","Denmark","Armenia","Ukraine","Kosovo","Georgia","Moldova","Albania","Spain"] },
];
